import { render, staticRenderFns } from "./modal-referral-greetings.vue?vue&type=template&id=674ecf6a&scoped=true&"
import script from "./modal-referral-greetings.vue?vue&type=script&lang=ts&"
export * from "./modal-referral-greetings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ecf6a",
  null
  
)

export default component.exports